<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('edit') }} {{ $t('binNumbers') }}</div>
      <div>
        <router-link class="btn-blue" to="bin-Numbers">{{ $t('binNumbers') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label
              :class=" selected.bank && selected.bank.length > 0 ? 'shift-up' : '' "
            >{{ $t('select') }} {{ $t('bank') }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="disable"
                :text="selected.bank"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(bank,bankIndex) in banks"
                  :key="bankIndex"
                  @click="onSelectHandler('bank',bank)"
                  name="bank"
                  id="bank"
                >{{ bank.bank_name }}</b-dropdown-item>
              </b-dropdown>
              <Tooltip :title="$t('bankname')" />
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <div class="col-md-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                :disabled="disable"
                placeholder="."
                type="text"
                name="card_type"
                id="card_type"
                v-model="CardType"
              />
              <label>{{ $t('cardtype') }}</label>
            </div>
            <Tooltip :title="$t('cardtype')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('card_type')">{{ errors.first('card_type') }}</span>
          </p>
        </div>

        <div class="col-md-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                name="card_type"
                id="card_type"
                v-model="binNumbers"
              />
              <label>{{ $t('binNumbers') }}</label>
            </div>
            <Tooltip :title="$t('addbinNumber')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('card_type')">{{ errors.first('card_type') }}</span>
          </p>
        </div>
      </div>

      <div class="col-md-12 text-center mt-4">
        <button
          :disabled="btenable"
          @click.prevent.stop="onFinalSubmit()"
          class="btn-blue"
        >{{ $t('update') }}</button>
        <b-button class="btn-outline-grey" variant="default" to="bin-Numbers">{{ $t('cancel') }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      btenable: false,
      submitted: false,
      selected: {
        bank: ""
      },
      bank_id: "",
      binNumbers: [],
      BinList: [],
      binNumberFile: { file_url: "" },
      banks: [],
      result: [],
      showManual: false,
      BinInputs: [
        {
          bank_id: null,
          bin_card_type: "",
          bin_number: ""
        }
      ],
      CardType: "",
      CardTypeCopy: "",
      bin_id: null,
      disable: true
    };
  },

  beforeMount() {
    this.bin_id = this.$route.query.bin_id;
    this.bank_id = this.$route.query.bank_id;
    this.GetBinNumber();
  },
  mounted() {},
  methods: {
    GetBinNumber: function() {
      let payload = {
        bin_id: this.bin_id,
        bank_id: this.bank_id
      };
      MarketingService.viewBinNumbers(payload).then(response => {
        const { data } = response;

        if (data && data.status) {
          if (data.Records && data.Records.length > 0) {
            console.log("data.Records :>> ", data.Records);
            this.getBankList(data.Records[0].bank_id);
            this.CardType = data.Records[0].bin_card_type;
            this.CardTypeCopy = data.Records[0].bin_card_type;
            this.binNumbers = data.Records[0].bin_ranges;
          }
        }
      });
    },
    getBankList: function() {
      // this.banks = [];
      let payload = {
        tableName: "ms_banks",
        bank_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          // console.log("data :", data);
          if (data.status && data.Records.length > 0) {
            this.banks = data.Records;

            this.banks.map(x => {
              if (x.bank_id == this.bank_id) {
                this.selected.bank = x.bank_name;
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onFinalSubmit: function() {
      this.submitted = true;

      if (this.selected.bank.length == 0) {
        return;
      } else {
        let payload = {
          bin_id: this.bin_id,
          bank_id: this.bank_id,
          cardType: this.CardType,
          binNumber: this.binNumbers
        };

        this.btenable = true;
        let loader = this.$loading.show();

        MarketingService.editBinNumbers(payload)
          .then(response => {
            this.btenable = false;
            const { data } = response;
            // this.onResetForm();
            if (data.status) {
              this.$toasted.show(data.message);
              this.$router.push({
                path: "/marketing/bin-Numbers"
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },

    onSelectHandler: function(type, value) {
      if (type == "bank") {
        this.bank_id = value.bank_id;
        this.selected.bank = value.bank_name;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/BinNumbersComponents/editBinNumbers.vue